export default __webpack_public_path__ + "static/media/diagram-it.041061da.webp";